export const NASA_APOD = 'https://api.nasa.gov/planetary/apod?api_key=Yrja3bLw01M9UeHZ9gxM8E0Nui5sz8HxBt5EWFkN'